import { Badge } from "@/components/ui/badge";
import { Circle, Clock, CheckCircle2, AlertTriangle, AlertOctagon, CalendarDays, Minus } from "lucide-react";
import { cn } from "@/lib/utils";

/* SHB Finans paleti: nötr gri / amber / kırmızı / yeşil — her etiket ikon + metin taşır */

const statusMeta = {
  "Yapılacak": { icon: Circle, cls: "border-border bg-muted text-muted-foreground" },
  "Devam Ediyor": { icon: Clock, cls: "border-amber-200 bg-amber-50 text-amber-700 dark:border-amber-500/30 dark:bg-amber-500/10 dark:text-amber-300" },
  "Tamamlandı": { icon: CheckCircle2, cls: "border-emerald-200 bg-emerald-50 text-emerald-700 dark:border-emerald-500/30 dark:bg-emerald-500/10 dark:text-emerald-300" },
};

const priorityMeta = {
  Normal: { icon: Minus, cls: "border-border bg-muted text-muted-foreground" },
  "Önemli": { icon: AlertTriangle, cls: "border-amber-200 bg-amber-50 text-amber-700 dark:border-amber-500/30 dark:bg-amber-500/10 dark:text-amber-300" },
  "Acil": { icon: AlertOctagon, cls: "border-crimson/25 bg-crimson/10 text-crimson dark:text-red-300" },
};

const bucketMeta = {
  overdue: { icon: AlertOctagon, cls: "border-transparent bg-crimson text-white" },
  today: { icon: CalendarDays, cls: "border-transparent bg-navy text-white dark:bg-slate-100 dark:text-navy" },
  upcoming: { icon: Clock, cls: "border-amber-200 bg-amber-50 text-amber-700 dark:border-amber-500/30 dark:bg-amber-500/10 dark:text-amber-300" },
  later: { icon: CalendarDays, cls: "border-border bg-muted text-muted-foreground" },
  none: { icon: AlertTriangle, cls: "border-dashed border-border bg-transparent text-muted-foreground" },
};

export const Pill = ({ children, className, testId, icon: Icon }) => (
  <Badge
    data-testid={testId}
    variant="outline"
    className={cn(
      "gap-1 rounded-lg border px-2 py-0.5 text-[11px] font-semibold normal-case whitespace-nowrap",
      className
    )}
  >
    {Icon && <Icon className="h-3 w-3" />}
    {children}
  </Badge>
);

export const StatusBadge = ({ status }) => {
  const m = statusMeta[status] || statusMeta["Yapılacak"];
  return <Pill testId={`status-badge-${status}`} icon={m.icon} className={m.cls}>{status}</Pill>;
};

export const PriorityBadge = ({ priority }) => {
  const m = priorityMeta[priority] || priorityMeta.Normal;
  return <Pill testId={`priority-badge-${priority}`} icon={m.icon} className={m.cls}>{priority}</Pill>;
};

export const BucketBadge = ({ bucket, label }) => {
  const m = bucketMeta[bucket] || bucketMeta.later;
  return <Pill testId={`bucket-badge-${bucket}`} icon={m.icon} className={m.cls}>{label}</Pill>;
};

export const SectionBadge = ({ section }) => (
  <Pill
    testId={`section-badge-${section}`}
    className={
      section === "TÜRKPATENT"
        ? "border-crimson/20 bg-crimson/8 text-crimson dark:text-red-300"
        : "border-border bg-muted text-foreground"
    }
  >
    {section}
  </Pill>
);
